import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AngularEmbedVideoService } from './angular-embed-video.service';



@NgModule({
  imports: [HttpClientModule],
	providers: [AngularEmbedVideoService]
})
export class AngularEmbedVideoModule { }
